import React from 'react'
import clsx from 'clsx'
import styles from './UIGameDiceProb.module.scss'
import Prob2 from '@static/images/prob_2.svg'
import Prob3 from '@static/images/prob_3.svg'
import Prob4 from '@static/images/prob_4.svg'
import Prob5 from '@static/images/prob_5.svg'
import Prob6 from '@static/images/prob_6.svg'
import Prob8 from '@static/images/prob_8.svg'
import Prob9 from '@static/images/prob_9.svg'
import Prob10 from '@static/images/prob_10.svg'
import Prob11 from '@static/images/prob_11.svg'
import Prob12 from '@static/images/prob_12.svg'
import {ImageURL} from '@colonist/types'

export interface UIGameDiceProbProps {
    value: number
    className?: string
}

type DieFace = 2 | 3 | 4 | 5 | 6 | 8 | 9 | 10 | 11 | 12
const probByDiceNumber: Record<DieFace, ImageURL> = {
    2: Prob2,
    3: Prob3,
    4: Prob4,
    5: Prob5,
    6: Prob6,
    8: Prob8,
    9: Prob9,
    10: Prob10,
    11: Prob11,
    12: Prob12,
} as const

export function getProbabilityImage(prob: number): ImageURL {
    const allowedDiceNumbers = [2, 3, 4, 5, 6, 8, 9, 10, 11, 12]
    if(!allowedDiceNumbers.includes(prob)) prob = 2

    return probByDiceNumber[prob]
}

export function UIGameDiceProb({
    value,
    className,
}: UIGameDiceProbProps) {
    const probImage = getProbabilityImage(value)
    return (
        <img
            draggable={false}
            className={clsx(styles.prob, className)}
            src={probImage}
        />
    )
}
